<template>
  <div class="pagelist">
   <Table border :columns="columns1" :data="data1">
       <template slot-scope="{ row }" slot="address">
            {{row.address}}
        </template>
   </Table>
  </div>
</template>

<script>
 export default {
        data () {
            return {
                columns1: [
                    {
                        title: '名称',
                        key: 'name',
                        width: 120,
                    },
                    {
                        title: 'URL',
                        slot: 'address',
                    }
                ],
                data1: [
                    {
                        name: '仿微信聊天1',
                        address: 'http://m.cdomick.com/#/chatpage',
                    },
                     {
                        name: '仿微信聊天',
                        address: 'http://m.cdomick.com/#/chatpage2',
                    },
                       {
                        name: '名师风采',
                        address: 'http://m.cdomick.com/#/teacher',
                    },
                       {
                        name: '学生作品',
                        address: 'http://m.cdomick.com/#/works',
                    },
                       {
                        name: '新闻中心',
                        address: 'http://m.cdomick.com/#/news',
                    },
                       {
                        name: '学校简介',
                        address: 'http://m.cdomick.com/#/school',
                    },
                       {
                        name: '就业创业',
                        address: 'http://m.cdomick.com/#/jobs',
                    },
                          {
                        name: '学校环境',
                        address: 'http://m.cdomick.com/#/place',
                    },
                       {
                        name: '热门课程',
                        address: 'http://m.cdomick.com/#/class',
                    },
                       {
                        name: '咖啡9个月',
                        address: 'http://m.cdomick.com/#/coffee',
                    },
                       {
                        name: '西点15个月',
                        address: 'http://m.cdomick.com/#/baking15',
                    },
                       {
                        name: '西点9个月',
                        address: 'http://m.cdomick.com/#/baking9',
                    },
                          {
                        name: '西点6个月',
                        address: 'http://m.cdomick.com/#/baking6',
                    },
                       {
                        name: '西点3个月',
                        address: 'http://m.cdomick.com/#/baking3',
                    },
                       {
                        name: '西点1个月',
                        address: 'http://m.cdomick.com/#/baking1',
                    },
                       {
                        name: '西餐9个月',
                        address: 'http://m.cdomick.com/#/westfood9',
                    },
                       {
                        name: '西餐6个月',
                        address: 'http://m.cdomick.com/#/westfood6',
                    },
                       {
                        name: '调酒2个月',
                        address: 'http://m.cdomick.com/#/wine',
                    },
                       {
                        name: '我要开店',
                        address: 'http://m.cdomick.com/#/shop',
                    },
                         {
                        name: '蛋糕',
                        address: 'http://m.cdomick.com/#/cake',
                    },
                       {
                        name: '春招',
                        address: 'http://m.cdomick.com/#/spring',
                    },
                       {
                        name: '学费',
                        address: 'http://m.cdomick.com/#/tuition',
                    },
                         {
                        name: '专业总页面',
                        address: 'http://m.cdomick.com/#/bakingAll',
                    },
                       {
                        name: '女生',
                        address: 'http://m.cdomick.com/#/girl',
                    },
                       {
                        name: '法式甜点',
                        address: 'http://m.cdomick.com/#/dessert',
                    },
                         {
                        name: '初中生',
                        address: 'http://m.cdomick.com/#/middle',
                    },
                       {
                        name: '创业',
                        address: 'http://m.cdomick.com/#/business',
                    },
                       {
                        name: '泛人群专业',
                        address: 'http://m.cdomick.com/#/industry',
                    },
                         {
                        name: '烘焙表单',
                        address: 'http://m.cdomick.com/#/bakingform',
                    },
                       {
                        name: '烘焙甜点',
                        address: 'http://m.cdomick.com/#/bakingmini',
                    },
                       {
                        name: '蛋糕 新',
                        address: 'http://m.cdomick.com/#/newcake',
                    },
                        {
                        name: '法甜',
                        address: 'http://m.cdomick.com/#/fatan',
                    },
                       {
                        name: '咖啡单页',
                        address: 'http://m.cdomick.com/#/coffeepage',
                    },
                        {
                        name: '西点单页',
                        address: 'http://m.cdomick.com/#/bakingpage',
                    },
                       {
                        name: '西点单页',
                        address: 'http://m.cdomick.com/#/bread',
                    },
                        {
                        name: '港式甜品',
                        address: 'http://m.cdomick.com/#/hksweet',
                    },
                       {
                        name: '西餐总页面',
                        address: 'http://m.cdomick.com/#/westfoodall',
                    },
                        {
                        name: '西餐总页面',
                        address: 'http://m.cdomick.com/#/zjc',
                    },
                       {
                        name: '初高中学技术',
                        address: 'http://m.cdomick.com/#/xuejishu',
                    },
                        {
                        name: '男生学技术',
                        address: 'http://m.cdomick.com/#/xuejishuboy',
                    },
                       {
                        name: '品牌落地页',
                        address: 'http://m.cdomick.com/#/brand',
                    },
                        {
                        name: '法式甜点',
                        address: 'http://m.cdomick.com/#/fstd',
                    },
                          {
                        name: '短期综合课程',
                        address: 'http://m.cdomick.com/#/duanqi',
                    },
                         {
                        name: '国朝中式点心',
                        address: 'http://m.cdomick.com/#/guochao',
                    },
                         {
                        name: '新版烘焙西餐',
                        address: 'http://m.cdomick.com/#/xidian',
                    }
                ]
            }
        }
    }
</script>

<style>
.pagelist{
    width: 96%;
    padding: 20px 2%;
}

</style>